var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemsTable',{attrs:{"headers":_vm.headers,"rows":_vm.rows,"get-data":_vm.getData,"has-more-data":_vm.hasMoreData,"is-loading":_vm.isLoading},on:{"clickRow":_vm.goToMemberDetail}},[_vm._t("buttons",null,{"slot":"buttons"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }